import { createFileRoute } from "@tanstack/react-router";

import InvoiceRepositoryPage from "@/features/dashboard/pages/invoice-repository";

export const Route = createFileRoute("/(app)/dashboard/invoice-repository")({
  component: () => <InvoiceRepositoryPage />,
});
